import React from "react";
import TextEditor from "@icarius-common/textEditor";
import Container from "../../../container";
import TextToSpeech from "@icarius-common/textToSpeech";
import { formatDraftToText } from "@icarius-utils/format";

const TextContent = (props) => {

    const {
        data,
    } = props;

    if (!data) return null;

    return (
        <Container>
            <TextEditor
                initialValue={data}
                maxHeight={"100%"}
                disabled
            />
            <div style={{ paddingTop: 10 }}>
                <TextToSpeech
                    text={formatDraftToText(data)}
                />
            </div>
        </Container>
    )
}

export default TextContent;